module.exports = __webpack_public_path__ + "img/head.df971e17.png";